import React from 'react';
import PropTypes from 'prop-types';

import FormatGraphDataService from 'components/year-review/services/FormatGraphDataService';

const YRCustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
    data,
    index,
    colors,
}) => {
    const RADIAN = Math.PI / 180;
    const radius = 32 + innerRadius + (outerRadius - innerRadius);
    const x = cx + (radius * Math.cos(-midAngle * RADIAN));
    const y = cy + (radius * Math.sin(-midAngle * RADIAN));

    return (
        <text
            x={x}
            y={y}
            fill="#8884d8"
            textAnchor={x > cx ? 'start' : 'end'}
            dominantBaseline="central"
        >
            <tspan
                y={y - 20}
                x={x}
                fontSize="1.5rem"
                fill={colors[index]}
            >
                {data[index].name}
            </tspan>
            <tspan
                x={x}
                y={y}
                fill="#000000"
                fontWeight={100}
                fontSize={12}
            >
                {Number.isInteger(value)
                    ? FormatGraphDataService.addCommas(value)
                    : FormatGraphDataService.twoDecimalPlaces(value)}%
            </tspan>
        </text>
    );
};

YRCustomLabel.defaultProps = {
    index: 0,
    cx: 0,
    cy: 0,
    midAngle: 0,
    innerRadius: 0,
    outerRadius: 0,
    value: 0,
    colors: ['#000000'],
};

YRCustomLabel.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    index: PropTypes.number,
    cx: PropTypes.number,
    cy: PropTypes.number,
    midAngle: PropTypes.number,
    innerRadius: PropTypes.number,
    outerRadius: PropTypes.number,
    value: PropTypes.number,
    colors: PropTypes.arrayOf(PropTypes.string),
};

export default YRCustomLabel;
